import { useRemoveAccount } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"

import { useAccount } from "./useAccount"
import { useAuthContext } from "src/contexts/AuthContext"
import { noticeError } from "src/utils"

export function useDeleteAccount() {
  const removeAccount = useRemoveAccount()
  const { clearAuthCookie } = useAuthContext()

  const { data: account } = useAccount()

  const accountId = account?.id

  return useMemo(
    () => !removeAccount || !accountId ? undefined : async () => {
      try {
        if (!removeAccount || !accountId) {
          throw new Error("cannot delete account for unauthorized user")
        }

        // when this succeeds the server revokes all of the user's auth tokens
        const response = await removeAccount(accountId)
        clearAuthCookie()

        return response
      } catch (e) {
        noticeError(
          e,
          "DeleteAccount",
          { accountId },
        )

        throw e
      }
    },
    [
      accountId,
      removeAccount,
      clearAuthCookie,
    ],
  )
}
